module.exports = __webpack_public_path__ + "img/Goin_1.c362b713.jpg";